import { Card, CardBody, Col } from 'reactstrap'
import { MixedCharts } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { mixChartData } from '../../../../Data/Charts/ApexChart/ApexChartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const MixedChart = () => {
  return (
    <Col sm="12" xl="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={MixedCharts} />
        <CardBody>
          <div id="mixedchart">
            <ReactApexChart options={mixChartData} series={mixChartData.series} type="line" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default MixedChart